module.exports = __webpack_public_path__ + "static/img/SOS_blue.1151a3b3.png";